<div fxLayout="column"  style="width:24vw;height:40vh" fxLayoutGap="20px"  >
  <div  fxLayoutAlign="end end" >
    <mat-icon style="cursor: pointer;" (click)="closePopup()">close</mat-icon>
  </div>
  <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="2px">
    <label mat-dialog-title class="apiKeyHeader">Are you sure that you want to re-generate API Key?</label>
    <p class="apiKey-sublabel">Please note that your API Key can only be generated if KYC is verified</p>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center" style="width:100%" fxLayoutGap="10px">
    <button class="verify-btn" fxFlex="40" fxLayoutAlign="center center" style="padding: 8px 0;background-color: #fff;border:1px solid #386AF6"
      (click)="closePopup()">No<mat-icon>
        chevron_right
      </mat-icon></button>
    <button class="verify-btn" fxLayoutAlign="center center" fxFlex="40" style="padding: 8px 0;background: #386AF6; color:#fff;font-family: 'Montserrat';
  font-style: normal;font-size: 14px; " (click)=" emailVerifyPopup();getApiKeyOTP();closePopup();">Yes<mat-icon>
        chevron_right
      </mat-icon>
    </button>
  </div>
  <div fxLayout="column"  fxLayoutAlign="center center">
    <label class="email-otp">We will be sending 6 digit OTP to your registered email address for authentication</label>
  </div>
</div>

